export default {"src":"/_next/static/media/Group2.8a417296.svg","height":56,"width":70,"blurWidth":0,"blurHeight":0};